document.addEventListener('DOMContentLoaded', function () {
  const searchBtn = document.querySelector('.b-h__search-btn');
  const searchWrap = document.querySelector('.b-search_header');
  const closeBtn = document.querySelector('.b-search__close');

  if (!searchBtn || !searchWrap) return;

  searchBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    searchWrap.classList.add('b-search_opened');
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      searchWrap.classList.remove('b-search_opened');
    });
  }

  document.addEventListener('click', function (e) {
    if (!searchWrap.contains(e.target) &&
      !searchBtn.contains(e.target)) {
      searchWrap.classList.remove('b-search_opened');
    }
  });
});
